/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable global-require */
/* eslint-disable react/button-has-type */
import React, { useEffect, useState, useContext } from 'react';
import { Col, Row, Image, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { SpinnerDotted } from 'spinners-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import { TableContext } from '../../contexts/tableContext';
import { getCookies } from '../../hooks/useCookies';
import styles from './settings.module.scss';
import defaultImage from '../../assets/avatar.png';
import envValues from '../../enviornment';

function ProfilePage() {
  const profile = `${getCookies('PROFILE')}`;
  const { bodyStyle } = useContext(TableContext);
  const { setDashboardHeader } = useContext(TableContext);
  const { formthemeStyle } = useContext(TableContext);
  const { viewformStyle } = useContext(TableContext);
  const { settingsgeneralSetStyle, settingsapiSetStyle } = useContext(TableContext);
  const userId = `${getCookies('USERID')}`;
  const token = `Bearer ${getCookies('Token')}`;
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState([]);
  const [roles, setRole] = useState([]);
  let statusCode;

  const getUserDetails = async () => {
    setLoading(true);
    axios
      .get(`${envValues.REACT_APP_API_ENDPOINT}/user/${userId}`, {
        method: 'GET',
        headers: { Authorization: token },
      })
      .then((resp) => {
        statusCode = resp.status;
        return resp;
      })
      .then((res) => {
        if (statusCode === 200) {
          setDetails(res.data.data.user);
          setRole(res.data.data.user.role);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        return err;
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getUserDetails();
    setDashboardHeader('Settings');
    settingsgeneralSetStyle('settingsgeneral');
    settingsapiSetStyle('settingslinks');
  }, []);

  return (
    <div>
      {loading ? (
        <div style={{ textAlign: 'center', marginTop: '180px', color: '#7a68c2' }}>
          <SpinnerDotted style={{ color: '#207a4a' }} />
        </div>
      ) : (
        <div className={`${styles[bodyStyle]} profile_conatiner`}>
          <div className={`${styles[formthemeStyle]} form_container`} id={styles.addform}>
            <Container fluid>
              <Row>
                <Col xl={2} lg={2} md={12} sm={12}>
                  <div className={styles.profilepicdiv}>
                    <Image src={profile || defaultImage} alt="logo" className={styles.profilepic} />
                  </div>
                </Col>
                <Col xl={8} lg={9} md={12} sm={12}>
                  <Row>
                    <Col xl={3} lg={6} md={6}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Name</span>
                        {/* <p className={styles.empname}>{details.name}</p> */}
                        <p className={styles.empname}>
                          {details.name
                            ?.split(' ')
                            .map(
                              (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                            )
                            .join(' ') || 'N/A'}
                        </p>
                      </div>
                    </Col>
                    <Col xl={6} lg={6} md={6}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Email</span>
                        <p className={styles.empname}>{details.email}</p>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl={3} lg={6} md={6}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Role</span>
                        <p className={styles.empname}>
                          {roles?.name?.replace(/\b\w/g, (char) => char.toUpperCase())}
                        </p>{' '}
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col xl={2} lg={4} md={12} sm={12}>
                  <div className={styles.editbtntop}>
                    <Link to="/profile-edit" className={`${styles.profileedit} edit_btn`}>
                      <FontAwesomeIcon icon={faPenToSquare} className={styles.penicon} />
                      Edit Profile
                    </Link>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProfilePage;
